/**
 * D9: the inverter's settings hold a 0 A charge or discharge current (read
 * through `strategy/dynamicControl/read`) — the battery does not charge
 * (discharge) whatever program is written; changed in DeyeCloud only.
 * Owner, 24.10.2026: the currents on the inverter are the ones Phage wrote
 * (22–23.10.2026), not the installer's — no grid charge until they set theirs.
 */
import type { SiteResponse } from 'shared';

import { useLocale } from '../i18n/locale-context.js';
import { zeroCurrentKey } from './inverter-program.js';

export function ZeroCurrentWarning({ site }: { site: SiteResponse }) {
  const { t } = useLocale();
  const key = zeroCurrentKey(site.inverter_settings.battery_currents);
  const byPhage = site.inverter_settings.currents_by_phage;
  if (!key && !byPhage) return null;
  return (
    <>
      {byPhage ? (
        <p className="err" role="alert" data-testid="currents-by-phage">
          {t('site.currents_by_phage')}
        </p>
      ) : null}
      {key ? (
        <p className="err" role="alert" data-testid="zero-current">
          {t(key)}
        </p>
      ) : null}
    </>
  );
}
